import axiosInstance from "@/api/axios-instance";
import { CreateBundleUsageRequest } from "@/pages/users/types/bundle-usage";

export async function createBundleUsage(data: CreateBundleUsageRequest) {
  const response = await axiosInstance.post("/usage/create-bundle-usage", data);

  if (!response.status.toString().startsWith("2")) {
    throw new Error("failed creating bundle usage");
  }

  return response.data;
}
